import HTMLReactParser from 'html-react-parser';

import * as St from './WarrantyDetailsModal.styles';

import { OptionalProduct } from '~/core/models';

type WarrantyDetailsModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  warrantyCandidate?: OptionalProduct;
};

const WarrantyDetailsModal = ({
  onClose,
  onConfirm,
  warrantyCandidate,
}: WarrantyDetailsModalProps) => (
  <St.WarningDetailModal
    open={!!warrantyCandidate}
    closable={false}
    footer={
      <St.ButtonsContainer>
        <St.Button onClick={onClose} data-style="warning-secondary">
          {'Cancel'}
        </St.Button>
        <St.Button onClick={onConfirm} data-style="warning-primary">
          {'Add'}
        </St.Button>
      </St.ButtonsContainer>
    }
  >
    <St.WarningDetailModalTitle>
      GRANITE GOLD<sup>®</sup> PROTECTION PLAN
    </St.WarningDetailModalTitle>
    {HTMLReactParser(warrantyInfoContent)}
  </St.WarningDetailModal>
);

export default WarrantyDetailsModal;

const warrantyInfoContent = `
<p>
  The Granite Gold<sup>®</sup> Protection Plan, is an affordable, worry-free way to ensure your new countertops last for years to come.
</p>
<p>
  The 5 and 10-Year Protection Plans cover common accidental damages that aren't covered by the material warranties.
</p>
<p>Both plans are available for the following countertop product lines:</p>
<ul>
  <li>allen + roth<sup>®</sup> Quartz</li>
  <li>allen + roth Granite</li>
  <li>allen + roth Solid Surface</li>
</ul>
<p>What is covered<sup>1</sup>:</p>
<p><b>Household Stains</b></p>
<ul>
  <li>Food and Beverage</li>
  <li>Cosmetics</li>
  <li>Oils</li>
  <li>Rust</li>
  <li>Human and pet bodily fluids / waste<sup>2</sup></li>
</ul>
<p style="color: #1F1F1F"><b>Accidental Damage</b></p>
<ul>
  <li>Chipping, pitting, and scratches</li>
  <li>Etching (dulling surfaces)</li>
  <li>Hard water marks and deposits</li>
  <li>Caulking, grout, and joint expansion</li>
</ul>
<p style="font-style: italic; font-size: 12px; padding-inline-start: 40px;">
    1: Certain limits, conditions, obligations, and exclusions apply
    <br />
    2: Not including perspiration, hair oils, or body oils
</p>
`;
